import React, { useMemo } from 'react'
import { ReactComponent as CalendarMoneyIcon } from 'assets/CalendarMoney.svg'
import { useCSDetailsCachedData } from 'components/configured-service/useCSDetailsCachedData'
import { selectBillingEndDate } from 'data/configured-service/configuredServiceDetailsSelectors'
import T from 'T'
import ServiceDetailChip from 'components/configured-service/layout/ServiceDetailChip'

const ServiceBillingEndDateChip = ({ id, ...props }) => {
  const { data = {} } = useCSDetailsCachedData({ id })
  const billingEndDate = useMemo(() => selectBillingEndDate(data), [data])

  return (
    <ServiceDetailChip
      IconComponent={CalendarMoneyIcon}
      label={billingEndDate}
      tooltip={T.BILLING_END_DATE}
      paletteColor="error"
      {...props}
    />
  )
}

export default ServiceBillingEndDateChip
